import { render, staticRenderFns } from "./ReadAgreement.vue?vue&type=template&id=417f2b09&"
import script from "./ReadAgreement.js?vue&type=script&lang=js&"
export * from "./ReadAgreement.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports